<!--<h1>{{IsShowDetail}}</h1>-->
<div *ngIf='!IsShowDetail'>
  <div class="modal-header">
    <h4 class="modal-title">Medical Record</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <!-- Form actions layout section start -->
    <section id="form-action-layouts">


      <div class="row justify-content-md-center">
        <div class="col-md-12">
          <div class="card">

            <div class="card-body">
              <div class="px-3">
                <form class="form" novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">


                  <div class="form-body">
                    <div class="row">
                      <div class="form-group col-12 mb-2">
                        <label for="eventInput1">Record Type</label>

                        <!--<CodeTypeValue CodeType="CRTYP" id="CurrentActorMedicalFitnessRequest.CredentialType" [(ngModel)]="CurrentActorMedicalFitnessRequest.CredentialType" name="CurrentActorMedicalFitnessRequest.CredentialType" required></CodeTypeValue>-->
                        <CustomDataByRequestType RequestedType="CredentialTypeByGroup" CustomType="ActorMedicalFitness" id="CurrentActorMedicalFitnessRequest.CredentialTypeCode"
                                                 [(ngModel)]="CurrentActorMedicalFitnessRequest.CredentialTypeCode" name="CurrentActorMedicalFitnessRequest.CredentialTypeCode" required
                                                 (keyChange)="onCredentialTypeByGroup($event)">
                        </CustomDataByRequestType>
                      </div>
                    </div>

                    <!--<div class="row">
                      <div class="form-group col-12 mb-2">
                        <label for="eventInput2">Record Number</label>
                        <input type="text" class="form-control" id="CurrentActorMedicalFitnessRequest.CredentialNumber" [(ngModel)]="CurrentActorMedicalFitnessRequest.CredentialNumber" name="CurrentActorMedicalFitnessRequest.CredentialNumber" placeholder="CredentialNumber" >
                      </div>
                    </div>-->


                    <div class="row">
                      <div class="form-group col-12 mb-2">
                        <label for="eventInput4">Date of Service</label>
                        <input type="date" class="form-control" id="CurrentActorMedicalFitnessRequest.ValidFrom" [(ngModel)]="CurrentActorMedicalFitnessRequest.ValidFrom" name="CurrentActorMedicalFitnessRequest.ValidFrom" placeholder="ValidFrom" >
                      </div>
                    </div>

                    <!--<div class="row">
                      <div class="form-group col-12 mb-2">
                        <label for="eventInput5">Valid To</label>
                        <input type="date" class="form-control" id="CurrentActorMedicalFitnessRequest.ValidTo" [(ngModel)]="CurrentActorMedicalFitnessRequest.ValidTo" name="CurrentActorMedicalFitnessRequest.ValidTo" placeholder="ValidTo" >
                      </div>
                    </div>-->
                    <!--<div class="row">
                      <div class="form-group col-12 mb-2">
                        <label for="eventInput5">Issuing Authority</label>

                        <CodeTypeValue CodeType="MFIAT" id="CurrentActorMedicalFitnessRequest.IssuingAuthority" [(ngModel)]="CurrentActorMedicalFitnessRequest.IssuingAuthority" name="CurrentActorMedicalFitnessRequest.IssuingAuthority" ></CodeTypeValue>
                      </div>
                    </div>-->
                    <div class="row">
                      <div class="form-group col-12 mb-2">
                        <label for="eventInput5">Additional Details</label>
                        <input type="text" class="form-control" id="CurrentActorMedicalFitnessRequest.AdditionalDetails" [(ngModel)]="CurrentActorMedicalFitnessRequest.AdditionalDetails" name="CurrentActorMedicalFitnessRequest.AdditionalDetails" placeholder="AdditionalDetails" >
                      </div>
                    </div>
                    <!--<div class="row">
                      <div class="form-group col-12 mb-2">
                        <label for="eventInput5">Remarks</label>
                        <input type="text" class="form-control" id="CurrentActorMedicalFitnessRequest.Remarks" [(ngModel)]="CurrentActorMedicalFitnessRequest.Remarks" name="CurrentActorMedicalFitnessRequest.Remarks" placeholder="Remarks" >
                      </div>
                    </div>-->
                    <div class="form-group">
                      <div class="col-md-12">
                        <button type="submit" [disabled]="!f.valid" *ngIf='!isRequesting' class="btn btn-pink btn-block btn-raised">Submit</button>

                      </div>
                    </div>


                  </div>


                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- // Form actions layout section end -->
  </div>


  <div class="modal-footer">
    <button type="button" class="btn btn-secondary btn-raised" (click)="activeModal.close('Close click')">Close</button>
  </div>
</div>
<div *ngIf='IsShowDetail'>
  <div class="modal-header">
    <h4 class="modal-title">Detail FitnessInfo</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <!-- Form actions layout section start -->
    <section id="form-action-layouts">


      <div class="row justify-content-md-center">
        <div class="col-md-12">
          <div class="card">

            <div class="card-body">
              <div class="px-3">
                <detail-grid *ngIf="CurrentActorMedicalFitnessInfoControllerByCode"
                             [columns]="dcolumns" [data]="CurrentActorMedicalFitnessInfoControllerByCode">

                </detail-grid>

              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- // Form actions layout section end -->
  </div>


  <div class="modal-footer">
    <button type="button" class="btn btn-secondary btn-raised" (click)="activeModal.close('Close click')">Close</button>
  </div>
</div>
